import React from 'react';

import {AuditProvider} from "../providers/AuditProvider"
import {ProductsProvider} from "../providers/ProductsProvider"

import ResultDetail from "./result-detail"

const ResultDetailPage = () => {
    return <AuditProvider>
              <ProductsProvider>
                  <ResultDetail />
              </ProductsProvider>
            </AuditProvider>
}

export default ResultDetailPage